import React from "react"
import { PageContext } from "./Page"
import Header from "./header/Header"
import Footer from "./footer/Footer"
import { Container } from "../utility/Containers"
import PropTypes from 'prop-types'
// import { Ticker } from "./Ticker"

const Layout = ({ footerDisclaimer = "", children }) => {
  // useEffect(() => {
  //   document.querySelector("meta[name=viewport]").setAttribute('content', 'width=device-width, initial-scale='+(1/window.devicePixelRatio))
  // }, [])

  return <PageContext.Consumer>
    {({ layout, lang }) => {
      const headerType = lang !== "pt" ? layout.headerType : 'only-logo'
      const footertype = lang !== "pt" ? layout.footerType : 'landing'

      return <Container>
        <Header type={headerType} theme={layout.headerTheme} isTransparent={layout.headerIsTransparent} />
        {/* <Ticker headerType={layout.headerType} /> */}
        {children}
        <Footer type={footertype} theme={layout.footerTheme} disclaimer={footerDisclaimer} />
      </Container>
    }}
  </PageContext.Consumer>
}
Layout.propTypes = {
  footerDisclaimer: PropTypes.object,
  children: PropTypes.element
}

export default Layout